/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactNode } from 'react';
import { Grid, Box } from '@mui/material';
import './CustomModal.css';
import CustomCancelButton from '../../components/CustomSmallButtons/CustomCancelButton';
import CustomAcceptButton from '../../components/CustomSmallButtons/CustomAcceptButton';
import CustomSaveButton from '../../components/CustomSmallButtons/CustomSaveButton';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';

interface handleClick {
  onClickSubmit?: any;
  onClickCancel?: any;
  onClickSave?: any;
  isSubmitButton?: boolean;
  isCancelButton?: boolean;
  isCloseButton?: boolean;
  isSaveButton?: boolean;
  title_for_submit_btn?: string;
  title_for_cancel_btn?: string;
  title_for_save_btn?: string;
  submitButtonDisable?: boolean;
  isSubmitting?: boolean;
  children?: ReactNode;
}

const ModalFooter: React.FC<handleClick> = ({
  onClickCancel,
  onClickSubmit,
  onClickSave,
  isSubmitButton = true,
  isCancelButton = true,
  isCloseButton = false,
  isSaveButton = false,
  title_for_submit_btn = 'Submit',
  title_for_cancel_btn = 'Cancel',
  title_for_save_btn = 'saved',
  submitButtonDisable = false,
  isSubmitting,
  children,
}) => {
  const { t } = useTranslation();
  const trans: any = t;
  const translated_submit_btn = trans(title_for_submit_btn);
  const translated_cancel_btn = trans(title_for_cancel_btn);
  const translated_save_btn = trans(title_for_save_btn);

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {isCancelButton && (
        <Box>
          <CustomCancelButton
            onClickCancel={onClickCancel}
            title={translated_cancel_btn}
          />
        </Box>
      )}

      {isCloseButton && (
        <Box
          style={{
            paddingLeft: '1.75em',
            paddingRight: '1.75em',
          }}
        >
          <CustomAcceptButton
            onClickSubmit={onClickCancel}
            title={trans('Close')}
            textTransform="uppercase"
          />
        </Box>
      )}

      {children}

      {isSaveButton && (
        <CustomSaveButton
          onClickSave={onClickSave}
          title={translated_save_btn}
          textTransform="uppercase"
        >
          {isSubmitting ? (
            <CircularProgress
              style={{
                width: '20px',
                height: '20px',
              }}
            />
          ) : null}
        </CustomSaveButton>
      )}

      {isSubmitButton && (
        <Box className="mx-1">
          <CustomAcceptButton
            onClickSubmit={onClickSubmit}
            title={translated_submit_btn}
            textTransform="uppercase"
            disable={submitButtonDisable || isSubmitting}
          >
            {isSubmitting ? (
              <CircularProgress
                style={{
                  width: '20px',
                  height: '20px',
                  color: 'white',
                }}
              />
            ) : null}
          </CustomAcceptButton>
        </Box>
      )}
    </Grid>
  );
};

export default ModalFooter;
